export const UPDATE_CUSTOMER_DETAILS = "UPDATE_CUSTOMER_DETAILS";
export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS";
export const UPDATE_CUSTOMER_VALIDATIONS = "UPDATE_CUSTOMER_VALIDATIONS";
export const UPDATE_QUOTATION_CUSTOMER_DETAILS = "UPDATE_QUOTATION_CUSTOMER_DETAILS";
export const UPDATE_CUSTOMER_ADDITIONAL_DETAIL = "UPDATE_CUSTOMER_ADDITIONAL_DETAIL";
export const UPDATE_ACCOUNT_MANAGER = 'UPDATE_ACCOUNT_MANAGER';
export const CREATE_NEW_CUSTOMER = 'CREATE_NEW_CUSTOMER';